import './styles.css';
import { useEffect } from 'react';
interface IProps {
  idVideo: string;
}

const Videozz = (props: IProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://vjs.zencdn.net/7.5.5/video.js';
    script.async = true;
    script.onload = () => {
      (window as any).vjsloaded = true;
    };

    document.body.appendChild(script);
  }, []);

  const { idVideo } = props;
  return (
    <div className='videozz'>
      <video
        id='my-video'
        poster={`https://nutror-videozz.s3.amazonaws.com/upload/${idVideo}.jpg`}
        className='video-js vjs-big-play-centered vjs-fill'
        controls
        preload='auto'
        data-setup='{}'
      >
        <source src={`https://nutror-videozz.s3.amazonaws.com/upload/${idVideo}.mp4`} type='video/mp4' />
      </video>
    </div>
  );
};

export default Videozz;
